import React, { useContext, useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { toast } from "react-toastify";
import R1SummerSession from "./RegistrationFormSteps/R1SummerSession.js";
import R2StudentInformation from "./RegistrationFormSteps/R2StudentInformation.js";
import R3ParentInformation from "./RegistrationFormSteps/R3ParentInformation.js";
import R4PhysicalAddress from "./RegistrationFormSteps/R4PhysicalAddress.js";
import R5MailingAddress from "./RegistrationFormSteps/R5MailingAddress.js";
import R6Ethnicity from "./RegistrationFormSteps/R6Ethnicity.js";
import R7PreviousSchoolInformation from "./RegistrationFormSteps/R7PreviousSchoolInformation.js";
import R8PrimaryLanguage from "./RegistrationFormSteps/R8PrimaryLanguage.js";
import R9HomeLanguage from "./RegistrationFormSteps/R9HomeLanguage.js";
import R10MigrantEducation from "./RegistrationFormSteps/R10MigrantEducation.js";
import R11ReleaseRequests from "./RegistrationFormSteps/R11ReleaseRequests.js";
import R12DassInformation from "./RegistrationFormSteps/R12DassInformation.js";
import R13HomeSurvey from "./RegistrationFormSteps/R13HomeSurvey.js";
import R14HealthConditions from "./RegistrationFormSteps/R14HealthConditions.js";
import R15ParentCustodyInformation from "./RegistrationFormSteps/R15ParentCustodyInformation.js";
import R16EmergencyContacts from "./RegistrationFormSteps/R16EmergencyContacts.js";
import R17PreviewSubmission from "./RegistrationFormSteps/R17PreviewSubmission.js";
import R18CompletionScreen from "./RegistrationFormSteps/R18CompletionScreen.js";
import R22StudentPreferences from "./RegistrationFormSteps/R22StudentPreferences.js";
import RegistrationContext from "../../context/registration/registrationContext";
import ProgressButtons from "./ProgressButtons";
import R33Parent2Information from "./RegistrationFormSteps/R33Parent2Information.js";
import findBrand from "../findBrand.js";
import { brandDomains, fetchBrands } from "../brand.js";
import ErrorLogger from "../ErrorLogger.js";

const RegistrationForm = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    formData,
    formLevel,
    levelUp,
    setPass,
    submitData,
    onFormDataChange,
    learningCenterName,
  } = registrationContext;

  const [submitted, setSubmitted] = useState(false);
  const [learningCenterId, setLearningCenterId] = useState("");
  
  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    try {
      if (validateFormData()) {
        //submitData({ ...formData });
        // Include learningCenterId in the form data when submitting
        // For RegistrationForm, uuid will be undefined/empty
        const submissionData = {
          ...formData,
          learningCenterId: learningCenterId,
          uuid: undefined // or "" - explicitly setting uuid as empty for regular registration
        };
        submitData(submissionData);
      } else {
        const validationError = "Validation failed";
        console.log(validationError);
        ErrorLogger.logError(validationError);
        toast.error("Please complete all required fields before submitting.", { autoClose: 2000 });
      }
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
      toast.error("An error occurred. Please try again.", { autoClose: 2000 });
    }
  };

  const validateFormData = () => {
    const {
      emergencyContact1FirstName,
      emergencyContact1LastName,
      emergencyContact1Phone,
      emergencyContact1Relationship,
      authorizedForPickup1,
      emergencyContact2FirstName,
      emergencyContact2LastName,
      emergencyContact2Phone,
      emergencyContact2Relationship,
      authorizedForPickup2,
      custodyIssueExists,
      custodyIssueNotes,
      legalRestrictionsForAnyParent,
      legalRestrictionsNotes,
    } = formData;

    if (findBrand(brand_holston) || findBrand(brand_pbia)) {
      const isCustodyValid =
        custodyIssueExists.yes === true || custodyIssueExists.no === true;

      const isLegalValid =
        legalRestrictionsForAnyParent.yes === true ||
        legalRestrictionsForAnyParent.no === true;

      return isCustodyValid && isLegalValid;
    } else {
      return (
        emergencyContact1FirstName !== "" &&
        emergencyContact1LastName !== "" &&
        emergencyContact1Phone !== "" &&
        emergencyContact1Relationship !== "" &&
        authorizedForPickup1 !== "" &&
        emergencyContact2FirstName !== "" &&
        emergencyContact2LastName !== "" &&
        emergencyContact2Phone !== "" &&
        emergencyContact2Relationship !== "" &&
        authorizedForPickup2 !== ""
      );
    }
  };
  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const siteId = urlParams.get('site');
    //console.log("learningCenterId", siteId);
    
    if (siteId) {
      setLearningCenterId(siteId);
      // Update form data with learningCenterId
      onFormDataChange({ target: { name: 'learningCenterId', value: siteId } });
    }
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  if (findBrand(brand_holston )=== true || findBrand(brand_pbia) === true) {
    return (
      <div id="registration-form">
        <h2 className="text-center"> Student Registration </h2>
        <form onSubmit={onSubmit} className="form">
          <div className="form-container">
            {/* {formLevel === 0 && <R1SummerSession />} */}
            {formLevel === 0 && <R2StudentInformation />}
            {formLevel === 1 && <R22StudentPreferences />}
            {formLevel === 2 && <R3ParentInformation />}
            {formLevel === 3 && <R33Parent2Information />}

            {formLevel === 4 && <R4PhysicalAddress />}
            {formLevel === 5 && <R5MailingAddress />}
            {formLevel === 6 && <R6Ethnicity />}
            {formLevel === 7 && <R7PreviousSchoolInformation />}
            {formLevel === 8 && <R8PrimaryLanguage />}

            {formLevel === 9 && <R11ReleaseRequests />}
            {formLevel === 11 && <R18CompletionScreen />}
            {/* {formLevel === 10 && <R15ParentCustodyInformation />} */}
            {formLevel === 10 && (
              <R15ParentCustodyInformation
                validateFormData={validateFormData}
                submitted={submitted}
              />
            )}
          </div>
          {formLevel === 10 && (
            <div>
              <div className="btn-container">
                <input
                  type="submit"
                  value="Submit"
                  className="btn btn-l4l-green"
                />
              </div>
            </div>
          )}
        </form>
      </div>
    );
  } else {
    return (
      <div id="registration-form">
        <h2 className="text-center"> Student Registration </h2>
        <form onSubmit={onSubmit} className="form">
          <div className="form-container">
            {/* {formLevel === 0 && <R1SummerSession />} */}
            {formLevel === 0 && <R2StudentInformation />}
            {formLevel === 1 && <R3ParentInformation />}
            {formLevel === 2 && <R4PhysicalAddress />}
            {formLevel === 3 && <R5MailingAddress />}
            {formLevel === 4 && <R6Ethnicity />}
            {formLevel === 5 && <R7PreviousSchoolInformation />}
            {formLevel === 6 && <R8PrimaryLanguage />}
            {formLevel === 7 && <R9HomeLanguage />}
            {formLevel === 8 && <R10MigrantEducation />}
            {formLevel === 9 && <R11ReleaseRequests />}
            {formLevel === 10 && <R12DassInformation />}
            {formLevel === 11 && <R13HomeSurvey />}
            {formLevel === 12 && <R14HealthConditions />}
            {formLevel === 13 && <R15ParentCustodyInformation />}
            {formLevel === 15 && <R18CompletionScreen />}

            {formLevel === 14 && (
              <R16EmergencyContacts
                validateFormData={validateFormData}
                submitted={submitted}
              />
            )}
          </div>
          {formLevel === 14 && (
            <div>
              <div className="btn-container">
                <input
                  type="submit"
                  value="Submit"
                  className="btn btn-l4l-green"
                />
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
};

export default RegistrationForm;
